import Vue from "vue";
import Router from "vue-router";

// router懒加载
// const selection = resolve => require(["@/page/selection"], resolve);
// const selectionMobile = resolve => require(["@/page/selectionMobile"], resolve);
// const summit = resolve => require(["@/page/summit"], resolve);
// const summitMobile = resolve => require(["@/page/summitMobile"], resolve);
// const person = resolve => require(["@/page/person"], resolve);
// const personMobile = resolve => require(["@/page/personMobile"], resolve);
// const activity = resolve => require(["@/page/activity"], resolve);
// // const vote = resolve => require(["@/page/vote"], resolve);
// const activityMobile = resolve => require(["@/page/activityMobile"], resolve);
// const irtopPc = resolve => require(["@/page/irtop"], resolve);
// const irtopMobile = resolve => require(["@/page/irtopMobile"], resolve);
const layout = resolve => require(["@/layout/default"], resolve);

Vue.use(Router);

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      name: "selection",
      redirect: { name: "selection" },
      component: layout,
    },
    {
      path: "/seventh",
      name: "seventh",
      component: layout,
      children: [
        // 候选报名期
        {
          path: "selectionPc",
          name: "selectionPc",
          redirect: "votePc",
          component: resolve => require(["@/page/seventh/pc/selection"], resolve),
          meta: {
            title: "第七届中国卓越IR评选"
          }
        },
        {
          path: "selection",
          name: "selection",
          redirect: "vote",
          component: resolve =>
            require(["@/page/seventh/mobile/selection"], resolve),
          meta: {
            title: "第七届中国卓越IR评选"
          }
        },
        {
          path: "activityPc",
          name: "activityPc",
          component: resolve => require(["@/page/seventh/pc/activity"], resolve),
          meta: {
            // title: "“数字之风 驭势而上”2023上市公司投资者关系创新峰会暨第七届中国卓越IR颁奖盛典"
            title: "东方拂晓2024上市公司投资者关系创新峰会暨第七届中国卓越IR颁奖盛典"
          }
        },
        {
          path: "activity",
          name: "activity",
          component: resolve =>
            require(["@/page/seventh/mobile/activity"], resolve),
          meta: {
            // title: "“数字之风 驭势而上”2023上市公司投资者关系创新峰会暨第七届中国卓越IR颁奖盛典"
            title: "东方拂晓2024上市公司投资者关系创新峰会暨第七届中国卓越IR颁奖盛典"
          }
        },

        // 网络投票期
        {
          path: "votePc",
          name: "votePc",
          redirect: 'outcomePc',
          component: resolve => require(["@/page/seventh/pc/vote"], resolve),
          meta: {
            title: "第七届中国卓越IR评选投票中 ｜助力卓越IR登顶！"
          }
        },
        {
          path: "voteListPc",
          name: "voteListPc",
          redirect: to => {
            return {
              path: 'outcomePc', query: {}
            }
          },
          component: resolve => require(["@/page/seventh/pc/vote/list"], resolve),
          meta: {
            title: "第七届中国卓越IR评选投票中 ｜助力卓越IR登顶！"
          }
        },
        {
          path: "voteDetailPc",
          name: "voteDetailPc",
          redirect: to => {
            return {
              path: 'outcomePc', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/pc/vote/detail"], resolve),
          meta: {
            title: "第七届中国卓越IR投票中，请为TA投票吧！"
          }
        },
        {
          path: "vote",
          name: "vote",
          redirect: "outcome",
          component: resolve => require(["@/page/seventh/mobile/vote"], resolve),
          meta: {
            title: "第七届中国卓越IR评选投票中 ｜助力卓越IR登顶！"
          }
        },
        {
          path: "voteList",
          name: "voteList",
          redirect: to => {
            return {
              path: 'outcome', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/mobile/vote/list"], resolve),
          meta: {
            title: "第七届中国卓越IR评选投票中 ｜助力卓越IR登顶！"
          }
        },
        {
          path: "voteDetail",
          name: "voteDetail",
          redirect: to => {
            return {
              path: 'outcome', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/mobile/vote/detail"], resolve),
          meta: {
            title: "第七届中国卓越IR投票中，请为TA投票吧！"
          }
        },

        // 综合评审期/入围通知
        {
          path: "evaluationPc",
          name: "evaluationPc",
          redirect: 'outcomePc',
          component: resolve =>
            require(["@/page/seventh/pc/evaluation"], resolve),
          meta: {
            title: "12月22日公布获奖名单 | 第七届中国卓越IR评选进入综合评审期"
          }
        },
        {
          path: "evaluationListPc",
          name: "evaluationListPc",
          redirect: to => {
            return {
              path: 'outcomePc', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/pc/evaluation/list"], resolve),
          meta: {
            title: "12月22日公布获奖名单 | 第七届中国卓越IR评选进入综合评审期"
          }
        },
        {
          path: "evaluationDetailPc",
          name: "evaluationDetailPc",
          redirect: to => {
            return {
              path: 'outcomePc', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/pc/evaluation/detail"], resolve),
          meta: {
            title: "12月22日公布获奖名单 | 第七届中国卓越IR评选进入综合评审期"
          }
        },
        {
          path: "evaluation",
          name: "evaluation",
          redirect: "outcome",
          component: resolve =>
            require(["@/page/seventh/mobile/evaluation"], resolve),
          meta: {
            title: "12月22日公布获奖名单 | 第七届中国卓越IR评选进入综合评审期"
          }
        },
        {
          path: "evaluationList",
          name: "evaluationList",
          redirect: to => {
            return {
              path: 'outcome', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/mobile/evaluation/list"], resolve),
          meta: {
            title: "12月22日公布获奖名单 | 第七届中国卓越IR评选进入综合评审期"
          }
        },
        {
          path: "evaluationDetail",
          name: "evaluationDetail",
          redirect: to => {
            return {
              path: 'outcome', query: {}
            }
          },
          component: resolve =>
            require(["@/page/seventh/mobile/evaluation/detail"], resolve),
          meta: {
            title: "12月22日公布获奖名单 | 第七届中国卓越IR评选进入综合评审期"
          }
        },

        // 颁奖典礼
        {
          path: "outcome",
          name: "outcome",
          component: resolve =>
            require(["@/page/seventh/mobile/outcome"], resolve),
          meta: {
            title: "重磅揭晓 | 第七届中国卓越IR评选最终获奖名单发布！"
          }
        },
        {
          path: "outcomeList",
          name: "outcomeList",
          component: resolve =>
            require(["@/page/seventh/mobile/outcome/list"], resolve),
          meta: {
            title: "重磅揭晓 | 第七届中国卓越IR评选最终获奖名单发布！"
          }
        },
        {
          path: "outcomeDetail",
          name: "outcomeDetail",
          component: resolve =>
            require(["@/page/seventh/mobile/outcome/detail"], resolve),
          meta: {
            title: "重磅揭晓 | 第七届中国卓越IR评选最终获奖名单发布！"
          }
        },
        {
          path: "outcomePc",
          name: "outcomePc",
          component: resolve => require(["@/page/seventh/pc/outcome"], resolve),
          meta: {
            title: "重磅揭晓 | 第七届中国卓越IR评选最终获奖名单发布！"
          }
        },
        {
          path: "outcomeListPc",
          name: "outcomeListPc",
          component: resolve =>
            require(["@/page/seventh/pc/outcome/list"], resolve),
          meta: {
            title: "重磅揭晓 | 第七届中国卓越IR评选最终获奖名单发布！"
          }
        },
        {
          path: "outcomeDetailPc",
          name: "outcomeDetailPc",
          component: resolve =>
            require(["@/page/seventh/pc/outcome/detail"], resolve),
          meta: {
            title: "重磅揭晓 | 第七届中国卓越IR评选最终获奖名单发布！"
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log(to,'router.beforeEach')
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js